import { handleActions } from "redux-actions";
import moment from "moment";

import {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS,
  SET_TABLE_LOADING,
  UPDATE_DATE,
  UPDATE_GROUP_BY_REVENUE_CATEGORY,
  UPDATE_INCLUDE_ZERO_SALES,
  UPDATE_STATUS_TYPES,
  RESET_FILTER_SELECTED
} from "./membershipBreakdownSaga";
import { API_DATE_FORMAT } from "../../../../app_constants";

export const actions = {
  SET_LOADING,
  FETCH_CURRENT_USER_SUCCESS,
  FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS,
  SET_TABLE_LOADING
};

export const initialState = {
  currentUser: {
    params: {}
  },
  initialRequest: false,
  membershipsInfo: {},
  membershipsPieChartValues: [],
  membershipsPercentagesByProductName: {},
  totalMembersCount: {},
  date: moment().format(API_DATE_FORMAT),
  minDate: "",
  statusTypesOptions: [
    { name: "Active", id: "active" },
    { name: "New", id: "new" }
  ],
  filters: {
    groupBy: [
      { name: "Revenue Category", id: "revenue_category" },
      { name: "Membership", id: "membership" }
    ],
    includeZeroSales: [
      { name: "Yes", id: "yes" },
      { name: "No", id: "no" }
    ]
  },
  selectedFilters: {
    includeZeroSales: { name: "Yes", id: "yes" },
    groupBy: { name: "Revenue Category", id: "revenue_category" }
  },
  selectedStatusTypes: { name: "Active", id: "active" },
  isLoading: true,
  tableLoading: false
};

const membershipTypeOption = { name: "Membership Type ", id: "membership_type" };

export default handleActions(
  {
    [UPDATE_DATE]: (state, action) => ({
      ...state,
      date: action.payload
    }),
    [UPDATE_GROUP_BY_REVENUE_CATEGORY]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        groupBy: action.payload
      }
    }),
    [RESET_FILTER_SELECTED]: (state) => ({
      ...state,
      selectedFilters: {
        ...initialState.selectedFilters,
        groupBy: state.currentUser.displayByMembershipType
          ? membershipTypeOption
          : initialState.selectedFilters.groupBy
      },
      date: initialState.date
    }),
    [UPDATE_INCLUDE_ZERO_SALES]: (state, action) => ({
      ...state,
      selectedFilters: {
        ...state.selectedFilters,
        includeZeroSales: action.payload
      }
    }),
    [UPDATE_STATUS_TYPES]: (state, { payload }) => ({
      ...state,
      selectedStatusTypes: payload,
      minDate:
        payload.id === "new"
          ? state.currentUser.forFilterNew.calendarStartDate
          : state.currentUser.calendarStartDate
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload || state.isLoading
    }),
    [SET_TABLE_LOADING]: (state, action) => ({
      ...state,
      tableLoading: action.payload
    }),
    [FETCH_CURRENT_USER_SUCCESS]: (state, { payload }) => {
      const { displayByMembershipType } = payload;

      return {
        ...state,
        initialRequest: true,
        currentUser: payload || state.currentUser,
        minDate: payload.calendarStartDate,
        filters: {
          ...state.filters,
          groupBy: displayByMembershipType
            ? [...initialState.filters.groupBy, membershipTypeOption]
            : initialState.filters.groupBy
        },
        selectedFilters: {
          ...state.selectedFilters,
          groupBy: displayByMembershipType
            ? membershipTypeOption
            : initialState.selectedFilters.groupBy
        }
      };
    },
    [FETCH_MEMBERSHIP_BREAKDOWN_SUCCESS]: (state, action) => ({
      ...state,
      date: action.payload.date || state.date,
      membershipsInfo: action.payload.membershipsInfo || state.membershipsInfo,
      membershipsPieChartValues:
        action.payload.membershipsPieChartValues || state.membershipsPieChartValues,
      membershipsPercentagesByProductName:
        action.payload.membershipsPercentagesByProductName ||
        state.membershipsPercentagesByProductName,
      totalMembersCount: action.payload.totalMembersCount || state.totalMembersCount,
      isLoading: false,
      tableLoading: false
    })
  },
  initialState
);
